'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { DASHBOARD_PERMISSION_DENIED, IS_READ_ONLY_DEMO_PROBLEM, LOADING, USER_SETTINGS_LACK_EDIT } from 'dashboard-lib/private/action-problem-solution/actions/static-widget-action/problem';
import { indexBy } from 'dashboard-lib/private/js-util';
import { createDisabledMessage } from '../common/disabled-message';
import { createReactMessage, getId } from '../common/message';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingProblemMessage = createReactMessage(LOADING, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.STATIC_WIDGET_ACTION.problem.LOADING"
}));
const EditProblemMessages = [LoadingProblemMessage, createReactMessage(USER_SETTINGS_LACK_EDIT, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.STATIC_WIDGET_ACTION.problem.USER_SETTINGS_LACK_EDIT.edit"
})), createReactMessage(DASHBOARD_PERMISSION_DENIED, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.STATIC_WIDGET_ACTION.problem.DASHBOARD_PERMISSION_DENIED.edit"
})), createReactMessage(IS_READ_ONLY_DEMO_PROBLEM, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.STATIC_WIDGET_ACTION.problem.IS_READ_ONLY_DEMO_PROBLEM.edit"
}))];
const DeleteProblemMessages = [LoadingProblemMessage, createReactMessage(USER_SETTINGS_LACK_EDIT, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.STATIC_WIDGET_ACTION.problem.USER_SETTINGS_LACK_EDIT.delete"
})), createReactMessage(DASHBOARD_PERMISSION_DENIED, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.STATIC_WIDGET_ACTION.problem.DASHBOARD_PERMISSION_DENIED.delete"
})), createReactMessage(IS_READ_ONLY_DEMO_PROBLEM, () => /*#__PURE__*/_jsx(FormattedMessage, {
  message: "reportingActions.STATIC_WIDGET_ACTION.problem.IS_READ_ONLY_DEMO_PROBLEM.delete"
}))];
const _editProblemToMessage = indexBy(getId, EditProblemMessages);
const _deleteProblemToMessage = indexBy(getId, DeleteProblemMessages);
export function getEditDisabledProblemMessage(params, problem) {
  return createDisabledMessage(params, problem, _editProblemToMessage);
}
export function getDeleteDisabledProblemMessage(params, problem) {
  return createDisabledMessage(params, problem, _deleteProblemToMessage);
}